import React from 'react';
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import BenefitSection from "../elements/benefit/BenefitSection";
import BenefitSection2 from "../elements/benefit/BenefitSection2";
import StopShop from "../elements/service/StopShop";
import ServiceOne from "../elements/service/ServiceOne";
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import Separator from "../elements/separator/Separator";
import { useTranslation } from "react-i18next";


const HowitWorks = () => {
    const { t } = useTranslation('enterprise');
    const ItWorks = [
        {
            image: "/images/bg/bg-home-1.png",
            title: t('fonctionnement.title'),
            description: t('fonctionnement.subtitle'),
        },
    ]
    return (
        <>
            <SEO title="N01ZET Comment ça marche - How it Works - Saas Platform Blockchain NFT" />
            <main className="page-wrapper main-mobile-responsive">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/* Start Slider Area  */}
                <div className="slider-area slider-style-1 variation-default height-850 bg_image" data-black-overlay="1" >
                    {ItWorks.map((data, index) => (
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="inner text-left">
                                    <h1 className="title display-one cust-title mt-5 pt-5" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                    <p className="description" style={{ fontSize: '20px' }} dangerouslySetInnerHTML={{__html: data.description}}></p>
                                    <div className="button-group">
                                        <Link className="btn-default btn-medium btn-icon" to="/contact">{t('buttons.demo')}<i className="icon"><FiArrowRight /></i></Link>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <img style={{ marginLeft: '80px', marginTop: '80px' }} className="bannerimg" alt='itworks' src="/images/bg/img-n01zet-fonctionnement.png" />
                            </div>
                        </div>
                    </div>
                    ))}
                </div>
                {/* End Slider Area  */}

                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('fonctionnement.simplicité.title')}
                                    description={t('fonctionnement.simplicité.subtitle')}
                                />
                            </div>
                        </div>
                        <BenefitSection2 
                         number=""
                         title={t('fonctionnement.simplicité.un.title')}
                         description={t('fonctionnement.simplicité.un.content')}
                         image="/images/split/works-1.png"
                        />
                        <BenefitSection 
                         number=""
                         title={t('fonctionnement.simplicité.deux.title')}
                         description={t('fonctionnement.simplicité.deux.content')}
                         image="/images/split/works-2.png"
                        />
                        <BenefitSection2 
                         number=""
                         title={t('fonctionnement.simplicité.trois.title')}
                         description={t('fonctionnement.simplicité.trois.content')}
                         image="/images/split/works-3.png"
                        />
                        <div className='text-center pt-5 mt-5'>
                        <Link className="btn-default btn-medium btn-icon" to="/contact">{t('buttons.demo')}<i className="icon"><FiArrowRight /></i></Link>
                        </div>
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator />
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="The principle"
                                    description="N01ZET offers a 100% digital solution for performance reward in the form of tokens whose value is guaranteed. The solution allows employees to choose to direct their tokens towards N01ZET savings, immediate payment or a whole range of exclusive advantages. N01ZET is an innovative system designed to help companies reward, develop and maintain employee loyalty."
                                />
                            </div>
                        </div>
                        <ServiceOne
                            serviceStyle="service__style--1 bg-color-blackest radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <Separator />   
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title={t('footer.offres')}
                                    description=""
                                />
                            </div>
                        </div>
                        <StopShop
                            serviceStyle="service__style--1 radius mt--20 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}

                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default HowitWorks
